import { consts } from '@allesauto/utils/consts';
import * as React from 'react';

import Footer from '@/components/Footer/Footer';

import HeaderContainer from '@/global/containers/HeaderContainer';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <HeaderContainer
        numOfNotificationsFavorite={
          consts.NAVIGATION_DUMMY_NOTIFICATIONS_NUMBER
        }
      />

      <div className="max-w-screen-xl mx-auto w-full">{children}</div>

      <Footer />
    </>
  );
}
